// src/pages/About.jsx

import React from "react";
import { Heart } from 'lucide-react';
import { PRIMARY_COLOR } from "../App";

export const About = () => (
    <div className="min-h-screen pt-32 bg-gray-900 text-white px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-gray-800 p-5 sm:p-8 rounded-xl shadow-2xl border border-gray-700">
            <h1 className={`text-3xl sm:text-4xl md:text-5xl font-extrabold ${PRIMARY_COLOR} mb-6 border-b border-teal-700 pb-3`}>
                Welcome to MEHAR TRADERS INTERNATIONAL LTD
            </h1>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
                Your go-to destination for quality sports nutrition and wellness products. We started as Amazon sellers and expanded into our own retail and wholesale platform to offer better value, better service, and a more personal experience.
            </p>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
                We partner with trusted wholesalers and suppliers to ensure every product is authentic, fresh, and high quality. From protein supplements to daily wellness favourites, our mission is to make top-tier nutrition accessible to everyone, including athletes, fitness lovers, retailers, and resellers alike.
            </p>
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
                At MEHAR TRADERS INTERNATIONAL LTD, we believe in honesty, fast service, and building long-term relationships. Your success is our success.
            </p>
            <div className="flex items-center space-x-3 text-teal-400">
                <Heart className="w-6 h-6 fill-teal-400" />
                <p className="font-semibold">Purity Guaranteed. Professional Results.</p>
            </div>
        </div>
    </div>
);

export default About;
